import { get } from "lodash"
import { createSelector } from "reselect"
import { getAllAvailableRollups } from "helpers/rollups"
import { getViewType, getIsActive } from "modules/portfolio-root/selectors/portfolios"
import { getTagCategories, getAttributeCategories } from "modules/portfolio-root/selectors"
import { getEndDate } from "selectors/dates"
import { getBasePositionSet } from "selectors/base"
import { getGroupingLabel } from "helpers/assets"
import { VIEW_TYPES } from "helpers/base"
import { computeFilteredSegment, filterSupportsContribution } from "helpers/segments"
import { getFilter, getNormalization } from "./filters"

export const getShowNotHeld = state => get(state, "modules.assetAnalytics.showNotHeld", false)
const getClassifications = (state) => get(state, "global.data.classifications.data.classifications")
const getGroupingRaw = state => get(state, "modules.assetAnalytics.grouping")
export const getHasUnexpandedComposites = state => get(state, "global.data.hasUnexpandedComposites.data", false)

export const getGrouping = createSelector(
  [getGroupingRaw, getIsActive],
  (grouping, isActive) => {
    if (grouping) {
      return {
        ...grouping,
        label: getGroupingLabel(grouping, isActive),
      }
    }
  },
)

export const getIsActiveView = createSelector(
  [getViewType],
  (viewType) => viewType === VIEW_TYPES.ACTIVE,
)

export const getIncludeNotHeld = createSelector(
  [getGrouping, getViewType],
  (grouping, viewType) => get(grouping, "id") !== "LONG_SHORT" && viewType === VIEW_TYPES.ACTIVE,
)

const getAccountRollups = createSelector(
  [getClassifications, getTagCategories, getAttributeCategories],
  (classifications, tagCategories, attributeCategories) => ({
    classifications,
    tagCategories,
    attributeCategories,
  }),
)

export const getAvailableRollups = createSelector(
  [getAccountRollups, getEndDate, getViewType, getIsActive],
  getAllAvailableRollups,
)

export const getSegment = createSelector(
  [getFilter, getNormalization],
  computeFilteredSegment,
)

export const getHasUnsupportedContributionFilter = createSelector(
  [getFilter, getIsActiveView],
  (filter, isActive) => !filterSupportsContribution(filter, isActive),
)

export const getBasePositionSetWithSegment = createSelector(
  [getBasePositionSet, getSegment],
  (basePositionSet, segment) => ({
    ...basePositionSet,
    segment,
  }),
)
